if (!customElements.get('popular-filters')) {
  class PopularFilters extends HTMLElement {
    constructor() {
      super();
      this.onLinkClick = this.onLinkClick.bind(this);
    }

    connectedCallback() {
      this.collectionUrl = this.dataset.collectionUrl;
      this.links = this.querySelectorAll('[data-popular-filter-link]');
      this.links.forEach((link) => link.addEventListener('click', this.onLinkClick));

      this.facetUpdateUnsubscriber = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate, (data) => {
        const queryParams =
          data?.queryParams instanceof URLSearchParams ? data.queryParams : new URLSearchParams(location.search);
        this.updateActiveStates(queryParams);
      });
    }

    disconnectedCallback() {
      this.links?.forEach((link) => link.removeEventListener('click', this.onLinkClick));
      this.facetUpdateUnsubscriber?.();
    }

    onLinkClick(event) {
      const form = document.querySelector('form[is="facet-form"]');
      // Without the facet form the link falls back to a regular page load.
      if (!form || typeof form.renderSection !== 'function') return;

      event.preventDefault();

      const link = event.currentTarget;
      const isActive = link.classList.contains('btn--active');
      // Popular filters replace every applied filter; clicking the active one clears back to the collection.
      const url = new URL(isActive ? this.collectionUrl : link.href, location.origin);
      const sortBy = new URLSearchParams(location.search).get('sort_by');
      if (sortBy) url.searchParams.set('sort_by', sortBy);
      url.searchParams.set('section_id', FoxTheme.utils.getSectionId(form));

      form.renderSection(url.toString(), event);
    }

    /**
     * @param {URLSearchParams} queryParams
     */
    updateActiveStates(queryParams) {
      const activeFilters = [];
      const activeGroups = new Set();

      for (const [paramName, value] of queryParams.entries()) {
        if (!paramName.startsWith('filter.') || value === '') continue;
        // Price range uses separate gte/lte params that together count as a single filter.
        activeGroups.add(paramName.replace(/\.(gte|lte)$/, ''));
        activeFilters.push({ paramName, value });
      }

      const soleFilter = activeGroups.size === 1 && activeFilters.length === 1 ? activeFilters[0] : null;

      this.links.forEach((link) => {
        const isActive =
          soleFilter !== null &&
          soleFilter.paramName === link.dataset.paramName &&
          soleFilter.value === link.dataset.paramValue;

        link.classList.toggle('btn--active', isActive);
        if (isActive) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }
  }

  customElements.define('popular-filters', PopularFilters);
}
